import React from 'react';
import { Column, Row, SkeletonLoader } from '@chargify/custom-ui-components';

const CustomFieldsLoadingSkeleton = () => (
  <Column span={[24, 17]}>
    <Row>
      <SkeletonLoader height={25} />
      <SkeletonLoader height={25} />
      <SkeletonLoader height={25} />
    </Row>
  </Column>
);

export default CustomFieldsLoadingSkeleton;
